import angular from 'angular'

import AutocompleteComponent from './vd-autocomplete.component'
import AutocompleteMultiComponent from './vd-autocomplete-multi/vd-autocomplete-multi.component'

angular
  .module('vend.ui')
  .component('vdAutocomplete', AutocompleteComponent)
  .component('vdAutocompleteMulti', AutocompleteMultiComponent)
